'use strict';
var populationElements = document.querySelectorAll('.population');
var totalOutput = document.querySelector('.total-population');
var averageOutput = document.querySelector('.average-population');
var populations = Array.from(populationElements).map(function(el) {
    return Number(el.textContent.replace(/,/g, ''));
});
var total = populations.reduce(function(acum, curr) {
    return acum + curr;
}, 0);
var average = Math.round(total / populations.length);
totalOutput.textContent = total.toLocaleString();
averageOutput.textContent = average.toLocaleString();

//# sourceMappingURL=js_get_data_DOM.b1f74f70.js.map
